import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

/** Barras empilhadas (concluídas vs restante) — mesmo tema escuro do AdminDashboard.jsx. */
export default function AgendaBars({ titulo, data }) {
  const semDados = data.every(d => d.total === 0);
  const chartData = data.map(d => ({ label: d.label, concluidas: d.concluidas, restante: Math.max(d.total - d.concluidas, 0) }));

  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-4">
      <h3 className="text-sm font-manrope font-semibold text-gray-900 mb-3">{titulo}</h3>
      {semDados ? (
        <p className="text-center text-xs text-gray-500 py-10">Nenhum dado neste período ainda</p>
      ) : (
        <ResponsiveContainer width="100%" height={160}>
          <BarChart data={chartData} margin={{ top: 0, right: 0, bottom: 0, left: -25 }}>
            <XAxis dataKey="label" tick={{ fill: '#6B7280', fontSize: 11, fontFamily: 'Manrope' }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fill: '#6B7280', fontSize: 11, fontFamily: 'Manrope' }} axisLine={false} tickLine={false} allowDecimals={false} />
            <Tooltip contentStyle={{ background: '#FFFFFF', border: '1px solid rgba(30,58,138,0.15)', borderRadius: 12, color: '#111827', fontFamily: 'Manrope', fontSize: 12 }} cursor={{ fill: 'rgba(30,58,138,0.08)' }} />
            <Bar dataKey="concluidas" stackId="a" fill="#22c55e" />
            <Bar dataKey="restante" stackId="a" fill="#E5E7EB" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
